export const settingsLinks = (translation) => {
  return [
    {
      url: '/settings/invoice-chars',
      name: translation.settingTab.InvoicePrefix,
    },
    { url: '/settings/tax-types', name: translation.settingTab.TaxTypes },
    { url: '/settings/sales-types', name: translation.settingTab.SaleTypes },
    {
      url: '/settings/payment-methods',
      name: translation.settingTab.PaymentMethods,
    },
    {
      url: '/settings/measurement-units',
      name: translation.settingTab.Measurement,
    },
    {
      url: '/settings/default-language',
      name: translation.settingTab.DefaultLanguage,
    },
  ];
};
